import React, { useEffect, useState, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  ZoomControl,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { FiSearch } from "react-icons/fi"; 

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const FlyToLocation = ({ position }) => {
  const map = useMap();
  useEffect(() => {
    if (position) {
      map.flyTo(position, 16, { duration: 1.5 });
    }
  }, [position, map]);
  return null;
};

const MapaProject = () => {
  const [coordenadas, setCoordenadas] = useState([]);
  const [busca, setBusca] = useState("");
  const [projetoSelecionado, setProjetoSelecionado] = useState(null);
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    fetch("/api/coordenadas")
      .then((res) => res.json())
      .then((data) => setCoordenadas(data))
      .catch((err) => console.log("Erro na busca", err));
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setMostrarSugestoes(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const coordenadaInicial = [-22.8164, -45.1933];

  const projetosFiltrados = coordenadas.filter((proj) =>
    proj.nome_projeto?.toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f4f8",
        padding: "20px",
        flexDirection: "column",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        ref={inputRef}
        style={{
          marginBottom: "20px",
          width: "80%",
          maxWidth: "600px",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "12px",
            padding: "10px 15px",
            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1)",
            transition: "all 0.3s ease",
          }}
        >
          <FiSearch
            style={{ fontSize: "20px", color: "#888", marginRight: "10px" }}
          />
          <input
            type="text"
            placeholder="Buscar projeto pelo nome..."
            value={busca}
            onChange={(e) => {
              setBusca(e.target.value);
              setMostrarSugestoes(true);
            }}
            style={{
              flex: 1,
              padding: "8px",
              border: "none",
              outline: "none",
              fontSize: "16px",
              background: "transparent",
            }}
          />
        </div>

        {mostrarSugestoes && busca && projetosFiltrados.length > 0 && (
          <div
            style={{
              background: "#fff",
              boxShadow: "0 3px 12px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              marginTop: "5px",
              maxHeight: "220px",
              overflowY: "auto",
              padding: "5px",
              zIndex: 1000,
              position: "absolute",
              width: "100%",
            }}
          >
            {projetosFiltrados.map((proj) => (
              <div
                key={proj.id}
                onClick={() => {
                  setProjetoSelecionado([proj.latitude, proj.longitude]);
                  setBusca(proj.nome_projeto);
                  setMostrarSugestoes(false);
                }}
                style={{
                  padding: "10px 12px",
                  cursor: "pointer",
                  borderRadius: "6px",
                  transition: "background 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#f1f5f9")}
                onMouseLeave={(e) =>
                  (e.target.style.background = "transparent")
                }
              >
                {proj.nome_projeto}
              </div>
            ))}
          </div>
        )}
      </div>

      <div
        style={{
          height: "550px",
          width: "80%",
          border: "none",
          borderRadius: "16px",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
          overflow: "hidden",
          background: "#fff",
          transition: "all 0.3s ease",
        }}
      >
        <MapContainer
          center={coordenadaInicial}
          zoom={13}
          style={{ height: "100%", width: "100%" }}
          zoomControl={false}
        >
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <ZoomControl position="bottomright" />
          <FlyToLocation position={projetoSelecionado} />

          {coordenadas.map((proj) => (
            <Marker key={proj.id} position={[proj.latitude, proj.longitude]}>
              <Popup>
                <div style={{ width: "220px", textAlign: "center" }}>
                  <img
                    src={proj.imagem || "https://via.placeholder.com/220"}
                    alt={`Projeto ${proj.nome_projeto}`}
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      marginBottom: "6px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    }}
                  />
                  <h4
                    style={{ margin: "5px 0", fontSize: "16px", color: "#333" }}
                  >
                    {proj.nome_projeto}
                  </h4>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>



    </div>
  );
};

export default MapaProject;
